import { graphql, useFragment } from "react-relay";
import { FormattedDate$key } from "./__generated__/FormattedDate.graphql";

import {
  useFormattedDate,
  useFormattedDateInWorkspaceTimeZone,
} from "./useFormattedDate";

const FRAGMENT = graphql`
  fragment FormattedDate on Date {
    ...useFormattedDate
  }
`;
export function FormattedDate(props: { date: FormattedDate$key }) {
  const date = useFragment(FRAGMENT, props.date);

  return useFormattedDate(date);
}

export function FormattedDateInWorkspace(props: { date: FormattedDate$key }) {
  const date = useFragment(FRAGMENT, props.date);

  return useFormattedDateInWorkspaceTimeZone(date);
}
